import i18n from 'modules/core/lib/i18n'

import { REVIEWER_TYPES } from 'modules/reviews/lib/reviewerTypes'

const ANONYMOUS = 'anonymous'

const title = (formName: string, key: string): string => {
  switch (key) {
    case REVIEWER_TYPES.SELF:
      return i18n.t('surveys.review.analytics.table.title.self', {
        name: formName,
      })

    case REVIEWER_TYPES.PEERS:
      return i18n.t('surveys.review.analytics.table.title.peer', {
        name: formName,
      })

    case REVIEWER_TYPES.REPORTEES:
      return i18n.t('surveys.review.analytics.table.title.reportee', {
        name: formName,
      })

    case REVIEWER_TYPES.MANAGER:
      return i18n.t('surveys.review.analytics.table.title.manager', {
        name: formName,
      })

    case REVIEWER_TYPES.MANUAL:
      return i18n.t('surveys.review.analytics.table.title.manual', {
        name: formName,
      })

    case ANONYMOUS:
      return i18n.t('surveys.review.analytics.table.title.anonymous', {
        name: formName,
      })

    default:
      throw new Error('Surveys/Analytics: Cannot find group type ' + key)
  }
}

const groupedByOptions = () => [
  {
    label: i18n.t('surveys.review.analytics.score.group_by.questions'),
    value: 'questions',
  },
  {
    label: i18n.t('surveys.review.analytics.score.group_by.sections'),
    value: 'sections',
  },
]

const aggregationOptions = () => [
  {
    label: i18n.t('surveys.review.analytics.score.aggregate.average'),
    value: 'avg',
  },
  {
    label: i18n.t('surveys.review.analytics.score.aggregate.sum'),
    value: 'sum',
  },
]

export { title, groupedByOptions, aggregationOptions }
